// Centralized i18n translations for 1:2000 Club
// Supported: en, sk, de
// Fallback: en

export const translations = {
  // ─── LANDING PAGE ───
  landing: {
    en: {
      hero: "Win Up To",
      heroDesc: "Join the most exclusive lottery. Only 2,000 tickets per draw at \u20AC150 each.",
      heroDesc2: "1 winner takes home \u20AC200,000. 20 more win \u20AC1,000 each.",
      claimSpot: "Claim your spot",
      login: "Login",
      limitedPool: "Limited Pool",
      limitedPoolDesc: "Only 2,000 spots available per draw, with one ticket allowed per player to ensure equal statistical winning odds for everyone. A fixed-player system designed to preserve fairness, transparency, and a truly exclusive experience for every participant.",
      instantDraw: "Instant Draw",
      instantDrawDesc: "Draw starts automatically when all 2,000 tickets are sold.",
      instantPayout: "Instant Payout",
      instantPayoutDesc: "Winnings credited directly to your wallet.",
      rng: "RNG",
      rngDesc: "Driven by RNG. Fair play in every round.",
      inviteFriends: "Invite Friends",
      inviteFriendsDesc: "Invite your friends and earn \u20AC20 from us for each one who joins.",
      faqTitle: "FAQ",
      joinNowTitle: "JOIN NOW !",
      joinStep1Title: "Do you want to join the club?",
      joinStep1Desc: "Click the button Claim your spot to create your account and secure your spot in the next draw.",
      joinStep2Title: "Get verified!",
      joinStep2Desc: "Registering takes just a few steps.",
      joinStep3Title: "Join & win!",
      joinStep3Desc: "Join the draw in just few steps. Deposit the entry amount, secure your spot in the pool and wait for the draw. Simple and transparent.",
      faq1q: "How do I participate in 1in2000 club?",
      faq1a: "Register an account, log in, deposit the entry amount and you will be automatically included in the next draw.",
      faq2q: "How do I deposit and receive winnings?",
      faq2a: "To participate, simply deposit the entry amount. After the draw is completed, any winnings are automatically paid to the secure account or payment method used for the deposit.",
      faq3q: "Is 1in2000club safe and fair?",
      faq3a: "Yes. We use advanced encryption to protect your data, and the draw is powered by a RNG generator that ensures fairness and transparency in every round.",
      faq4q: "Can I split the \u20AC150 entry with friends?",
      faq4a: "Yes. You can collect the \u20AC150 entry together using unique QR code and join the draw under one shared ticket. Example: You contribute \u20AC70, Friend 1 contributes \u20AC30 and Friend 2 contributes \u20AC50. Together you reach the required \u20AC150 entry and are included in the draw under one ticket. In case of win, the prize money is paid to the account that used to purchase the entry into the draw. All participants who contributed to the shared ticket will receive a notification if the ticket is a winning ticket.",
      faq5q: "What should I do if I need help?",
      faq5a: "You can contact our support team available 24/7 \u2014 for assistance with your account or any other questions.",
      faq6q: "How do you guarantee draw transparency?",
      faq6a: "We use a RNG (Random Number Generator) for the draw, which cannot be influenced or manipulated, even by us.",
      faq7q: "Why choose 1in2000Club?",
      faq7a: "Fixed and transparent rules \u2014 each round has exactly 2000 players. High winning chances compared to traditional lotteries. Fixed entry amount and predefined prize pool.",
      welcomeBack: "Welcome Back",
      joinClub: "Join 1:2000 Club",
      email: "Email",
      password: "Password",
      name: "Name",
      register: "Register",
      signIn: "Login",
      createAccount: "Create Account",
      creatingAccount: "Creating account...",
      startRegistration: "Start registration",
      nick: "Nickname",
      phone: "Phone",
      registerTermsPrefix: "I confirm the accuracy of the data and agree to the",
      registerTermsTerms: "terms",
      registerTermsPrivacy: "privacy policy",
      registerTermsKyc: "KYC/AML rules",
      registerTermsAnd: "and",
      regFlowStep1: "Nickname, password, email and optional phone",
      regFlowStep2: "ID document (both sides) + selfie",
      regFlowStep3: "Bank account for winnings",
      regFlowStep4: "Email confirmation",
      rememberMe: "Remember me",
      forgotPassword: "Forgot password?",
      regStep1: "Registration (email, password)",
      regStep2: "Fill in personal details",
      regStep3: "Upload ID",
      regStep4: "Selfie / Face verification",
      regStep5: "Approval / Rejection",
      regStep6: "Deposit enabled",
      regStep7: "Proof of address \u2014 required only for withdrawal",
      regStep8: "AML screening \u2014 automatic",
      noActiveDraw: "No active draw at the moment"
    },
    sk: {
      hero: "Vyhrajte a\u017E",
      heroDesc: "Pripojte sa k najexkluz\u00EDvnej\u0161ej lot\u00E9rii. Iba 2 000 l\u00EDstkov na \u017Erebovanie za \u20AC150 ka\u017Ed\u00FD.",
      heroDesc2: "1 v\u00ED\u0165az z\u00EDska \u20AC200 000. \u010Eal\u0161\u00EDch 20 vyhr\u00E1va po \u20AC1 000.",
      claimSpot: "Zabezpe\u010Dte si miesto",
      login: "Prihl\u00E1si\u0165 sa",
      limitedPool: "Obmedzen\u00FD pool",
      limitedPoolDesc: "K dispoz\u00EDcii iba 2 000 l\u00EDstkov na \u017Erebovanie. Jeden l\u00EDstok na hr\u00E1\u010Da zaru\u010Duje spravodlivos\u0165.",
      instantDraw: "Okam\u017Eit\u00E9 \u017Erebovanie",
      instantDrawDesc: "\u017Derebovanie sa spust\u00ED automaticky, ke\u010F sa predaj\u00FA v\u0161etky l\u00EDstky.",
      instantPayout: "Okam\u017Eit\u00E1 v\u00FDplata",
      instantPayoutDesc: "V\u00FDhry pr\u00EDp\u00EDsan\u00E9 priamo do va\u0161ej pe\u0148a\u017Eenky.",
      rng: "RNG",
      rngDesc: "Riaden\u00E9 certifikovan\u00FDm RNG. F\u00E9rov\u00E1 hra v ka\u017Edom kole.",
      inviteFriends: "Pozvi kamar\u00E1tov",
      inviteFriendsDesc: "Pozvi kamar\u00E1tov a za ka\u017Ed\u00E9ho z\u00EDska\u0161 od n\u00E1s \u20AC20.",
      faqTitle: "FAQ",
      joinNowTitle: "PRIPOJTE SA !",
      joinStep1Title: "Chcete sa pripoji\u0165 ku klubu?",
      joinStep1Desc: "Kliknite na tla\u010Didlo Zabezpe\u010Dte si miesto a vytvorte si \u00FA\u010Det, \u010D\u00EDm si zabezpe\u010D\u00EDte miesto v najbli\u017E\u0161om \u017Erebovan\u00ED.",
      joinStep2Title: "Overenie!",
      joinStep2Desc: "Registr\u00E1cia trv\u00E1 len p\u00E1r krokov.",
      joinStep3Title: "Zapojte sa a vyhrajte!",
      joinStep3Desc: "Zapojte sa do \u017Erebovania v nieko\u013Ek\u00FDch krokoch. Vlo\u017Ete vstupn\u00FA sumu, zabezpe\u010Dte si miesto v poole a \u010Dakajte na \u017Erebovanie. Jednoduch\u00E9 a transparentn\u00E9.",
      faq1q: "Ako sa z\u00FA\u010Dastn\u00EDm 1in2000 club?",
      faq1a: "Zaregistrujte si \u00FA\u010Det, prihl\u00E1ste sa, vlo\u017Ete vstupn\u00FA sumu a budete automaticky zaraden\u00ED do najbli\u017E\u0161ieho \u017Erebovania.",
      faq2q: "Ako vlo\u017E\u00EDm vklad a prijmem v\u00FDhry?",
      faq2a: "Na \u00FA\u010Das\u0165 jednoducho vlo\u017Ete vstupn\u00FA sumu. Po ukon\u010Den\u00ED \u017Erebovania bud\u00FA v\u0161etky v\u00FDhry automaticky vyplaten\u00E9 na zabezpe\u010Den\u00FD \u00FA\u010Det alebo platobn\u00FA met\u00F3du pou\u017Eit\u00FA pri vklade.",
      faq3q: "Je 1in2000club bezpe\u010Dn\u00FD a f\u00E9rov\u00FD?",
      faq3a: "\u00C1no. Pou\u017E\u00EDvame pokro\u010Dil\u00E9 \u0161ifrovanie na ochranu va\u0161ich \u00FAdajov a \u017Erebovanie je poh\u00E1\u0148an\u00E9 certifikovan\u00FDm RNG gener\u00E1torom, ktor\u00FD zabezpe\u010Duje f\u00E9rovos\u0165 a transparentnos\u0165 v ka\u017Edom kole.",
      faq4q: "M\u00F4\u017Eem si rozdeli\u0165 vstupn\u00E9 \u20AC150 s priate\u013Emi?",
      faq4a: "\u00C1no. M\u00F4\u017Eete spolo\u010Dne zozbiera\u0165 \u20AC150 vstupn\u00E9 pomocou unik\u00E1tneho QR k\u00F3du a zapoji\u0165 sa do \u017Erebovania pod jedn\u00FDm zdie\u013Ean\u00FDm l\u00EDstkom. Pr\u00EDklad: Vy prispejete \u20AC70, Priate\u013E 1 prispeje \u20AC30 a Priate\u013E 2 prispeje \u20AC50. Spolu dosiahnete po\u017Eadovan\u00FDch \u20AC150 a ste zaraden\u00ED do \u017Erebovania pod jedn\u00FDm l\u00EDstkom. V pr\u00EDpade v\u00FDhry sa v\u00FDhra vyplat\u00ED na \u00FA\u010Det, ktor\u00FD bol pou\u017Eit\u00FD na n\u00E1kup vstupu do \u017Erebovania. V\u0161etci \u00FA\u010Dastn\u00EDci, ktor\u00ED prispeli na zdie\u013Ean\u00FD l\u00EDstok, dostan\u00FA upozornenie, ak je l\u00EDstok v\u00FDhern\u00FD.",
      faq5q: "\u010Co m\u00E1m robi\u0165, ak potrebujem pomoc?",
      faq5a: "M\u00F4\u017Eete kontaktova\u0165 n\u00E1\u0161 t\u00EDm podpory dostupn\u00FD 24/7 \u2014 pre pomoc s va\u0161\u00EDm \u00FA\u010Dtom alebo ak\u00E9ko\u013Evek \u010Fal\u0161ie ot\u00E1zky.",
      faq6q: "Ako zaru\u010Dujete transparentnos\u0165 \u017Erebovania?",
      faq6a: "Pou\u017E\u00EDvame certifikovan\u00FD RNG (gener\u00E1tor n\u00E1hodn\u00FDch \u010D\u00EDsel) pre \u017Erebovanie, ktor\u00FD nemo\u017Eno ovplyvni\u0165 ani manipulova\u0165, dokonca ani nami.",
      faq7q: "Pre\u010Do si vybra\u0165 1in2000Club?",
      faq7a: "Pevn\u00E9 a transparentn\u00E9 pravidl\u00E1 \u2014 ka\u017Ed\u00E9 kolo m\u00E1 presne 2000 hr\u00E1\u010Dov. Vysok\u00E9 \u0161ance na v\u00FDhru v porovnan\u00ED s tradi\u010Dn\u00FDmi lot\u00E9riami. Pevn\u00E1 vstupn\u00E1 suma a vopred definovan\u00FD prize pool.",
      welcomeBack: "Vitajte sp\u00E4\u0165",
      joinClub: "Pripojte sa k 1:2000 Club",
      email: "Email",
      password: "Heslo",
      name: "Meno",
      register: "Registrova\u0165",
      signIn: "Prihl\u00E1si\u0165 sa",
      createAccount: "Vytvori\u0165 \u00FA\u010Det",
      creatingAccount: "Vytv\u00E1ra sa \u00FA\u010Det...",
      startRegistration: "Za\u010Da\u0165 registr\u00E1ciu",
      nick: "Prez\u00FDvka",
      phone: "Telef\u00F3n",
      registerTermsPrefix: "Potvrdzujem spr\u00E1vnos\u0165 \u00FAdajov a s\u00FAhlas\u00EDm s",
      registerTermsTerms: "podmienkami",
      registerTermsPrivacy: "ochranou s\u00FAkromia",
      registerTermsKyc: "KYC/AML pravidlami",
      registerTermsAnd: "a",
      regFlowStep1: "Prez\u00FDvka, heslo, email a voliteľn\u00FD telefón",
      regFlowStep2: "Doklad totožnosti z oboch str\u00E1n + selfie",
      regFlowStep3: "Bankov\u00FD \u00FA\u010Det na v\u00FDhry",
      regFlowStep4: "Potvrdenie emailovej adresy",
      rememberMe: "Zapam\u00E4ta\u0165 si ma",
      forgotPassword: "Zabudli ste heslo?",
      regStep1: "Registr\u00E1cia (email, heslo)",
      regStep2: "Vyplnenie osobn\u00FDch \u00FAdajov",
      regStep3: "Upload ID",
      regStep4: "Selfie / Face verification",
      regStep5: "Approval / Rejection",
      regStep6: "Povolenie vkladu",
      regStep7: "Proof of address \u2014 a\u017E pri v\u00FDbere v\u00FDhry",
      regStep8: "AML screening \u2014 automaticky",
      noActiveDraw: "Moment\u00E1lne \u017Eiadne akt\u00EDvne \u017Erebovanie"
    },
    de: {
      hero: "Gewinnen Sie bis zu",
      heroDesc: "Treten Sie der exklusivsten Lotterie bei. Nur 2.000 Tickets pro Ziehung zu je \u20AC150.",
      heroDesc2: "1 Gewinner nimmt \u20AC200.000 mit nach Hause. 20 weitere gewinnen je \u20AC1.000.",
      claimSpot: "Sichern Sie sich Ihren Platz",
      login: "Anmelden",
      limitedPool: "Begrenzter Pool",
      limitedPoolDesc: "Nur 2.000 Tickets pro Ziehung verf\u00FCgbar. Ein Ticket pro Spieler gew\u00E4hrleistet Fairness.",
      instantDraw: "Sofortige Ziehung",
      instantDrawDesc: "Die Ziehung startet automatisch, wenn alle 2.000 Tickets verkauft sind.",
      instantPayout: "Sofortige Auszahlung",
      instantPayoutDesc: "Gewinne werden direkt Ihrer Brieftasche gutgeschrieben.",
      rng: "RNG",
      rngDesc: "Gesteuert durch zertifizierten RNG. Faires Spiel in jeder Runde.",
      inviteFriends: "Freunde einladen",
      inviteFriendsDesc: "Laden Sie Freunde ein und erhalten Sie \u20AC20 von uns f\u00FCr jeden, der beitritt.",
      faqTitle: "FAQ",
      joinNowTitle: "JETZT BEITRETEN !",
      joinStep1Title: "M\u00F6chten Sie dem Club beitreten?",
      joinStep1Desc: "Klicken Sie auf die Schaltfl\u00E4che Sichern Sie sich Ihren Platz, um Ihr Konto zu erstellen und sich Ihren Platz in der n\u00E4chsten Ziehung zu sichern.",
      joinStep2Title: "Lassen Sie sich verifizieren!",
      joinStep2Desc: "Die Registrierung dauert nur wenige Schritte.",
      joinStep3Title: "Mitmachen & gewinnen!",
      joinStep3Desc: "Nehmen Sie in wenigen Schritten an der Ziehung teil. Zahlen Sie den Eintrittsbetrag ein, sichern Sie sich Ihren Platz im Pool und warten Sie auf die Ziehung. Einfach und transparent.",
      faq1q: "Wie nehme ich am 1in2000 Club teil?",
      faq1a: "Registrieren Sie ein Konto, melden Sie sich an, zahlen Sie den Eintrittsbetrags ein und Sie werden automatisch in die n\u00E4chste Ziehung aufgenommen.",
      faq2q: "Wie zahle ich ein und erhalte Gewinne?",
      faq2a: "Um teilzunehmen, zahlen Sie einfach den Eintrittsbetrag ein. Nach Abschluss der Ziehung werden alle Gewinne automatisch auf das sichere Konto oder die Zahlungsmethode ausgezahlt, die f\u00FCr die Einzahlung verwendet wurde.",
      faq3q: "Ist 1in2000club sicher und fair?",
      faq3a: "Ja. Wir verwenden fortschrittliche Verschl\u00FCsselung zum Schutz Ihrer Daten, und die Ziehung wird von einem zertifizierten RNG-Generator betrieben, der Fairness und Transparenz in jeder Runde gew\u00E4hrleistet.",
      faq4q: "Kann ich den \u20AC150-Eintritt mit Freunden teilen?",
      faq4a: "Ja. Sie k\u00F6nnen den \u20AC150-Eintritt gemeinsam \u00FCber einen einzigartigen QR-Code sammeln und unter einem gemeinsamen Ticket an der Ziehung teilnehmen. Beispiel: Sie tragen \u20AC70 bei, Freund 1 tr\u00E4gt \u20AC30 bei und Freund 2 tr\u00E4gt \u20AC50 bei. Zusammen erreichen Sie den erforderlichen \u20AC150-Eintritt. Im Falle eines Gewinns wird das Preisgeld auf das Konto ausgezahlt, das f\u00FCr den Kauf des Eintritts verwendet wurde. Alle Teilnehmer erhalten eine Benachrichtigung, wenn das Ticket gewinnt.",
      faq5q: "Was soll ich tun, wenn ich Hilfe brauche?",
      faq5a: "Sie k\u00F6nnen unser Support-Team kontaktieren, das rund um die Uhr erreichbar ist \u2014 f\u00FCr Hilfe mit Ihrem Konto oder andere Fragen.",
      faq6q: "Wie garantieren Sie die Transparenz der Ziehung?",
      faq6a: "Wir verwenden einen zertifizierten RNG (Zufallszahlengenerator) f\u00FCr die Ziehung, der nicht beeinflusst oder manipuliert werden kann, nicht einmal von uns.",
      faq7q: "Warum 1in2000Club w\u00E4hlen?",
      faq7a: "Feste und transparente Regeln \u2014 jede Runde hat genau 2000 Spieler. Hohe Gewinnchancen im Vergleich zu traditionellen Lotterien. Fester Eintrittsbetrag und vordefinierter Preispool.",
      welcomeBack: "Willkommen zur\u00FCck",
      joinClub: "Treten Sie dem 1:2000 Club bei",
      email: "E-Mail",
      password: "Passwort",
      name: "Name",
      register: "Registrieren",
      signIn: "Anmelden",
      createAccount: "Konto erstellen",
      creatingAccount: "Konto wird erstellt...",
      startRegistration: "Registrierung starten",
      nick: "Spitzname",
      phone: "Telefon",
      registerTermsPrefix: "Ich best\u00E4tige die Richtigkeit der Daten und stimme den",
      registerTermsTerms: "Bedingungen",
      registerTermsPrivacy: "Datenschutzbestimmungen",
      registerTermsKyc: "KYC/AML-Regeln",
      registerTermsAnd: "und",
      regFlowStep1: "Spitzname, Passwort, E-Mail und optional Telefon",
      regFlowStep2: "Ausweisdokument (Vorder- und R\u00FCckseite) + Selfie",
      regFlowStep3: "Bankkonto f\u00FCr Gewinne",
      regFlowStep4: "E-Mail-Best\u00E4tigung",
      rememberMe: "Angemeldet bleiben",
      forgotPassword: "Passwort vergessen?",
      regStep1: "Registrierung (E-Mail, Passwort)",
      regStep2: "Pers\u00F6nliche Daten ausf\u00FCllen",
      regStep3: "ID hochladen",
      regStep4: "Selfie / Gesichtsverifizierung",
      regStep5: "Genehmigung / Ablehnung",
      regStep6: "Einzahlung freigegeben",
      regStep7: "Adressnachweis \u2014 nur bei Auszahlung erforderlich",
      regStep8: "AML-Screening \u2014 automatisch",
      noActiveDraw: "Derzeit keine aktive Ziehung"
    }
  },

  // ─── DASHBOARD ───
  dashboard: {
    en: {
      tagline: "Where odds favor players",
      walletBalance: "Wallet Balance",
      locked: "Locked",
      welcome: "Welcome,",
      liveDesc: "Your live lottery dashboard",
      activeNow: "Active Now",
      prizePool: "Prize Pool",
      guaranteedFirstPrize: "Guaranteed first prize",
      mute: "Mute sound",
      unmute: "Unmute sound",
      logout: "Sign out",
      ticketsRemainingFomo: "tickets remaining — draw closes when 2000 sold",
      fillProgress: "Filling up",
      withdraw: "Withdraw",
      buyTicket: "Buy Ticket",
      preparingInvoice: "Preparing Invoice...",
      ticketPurchased: "Ticket Purchased",
      ticketNote: "Ticket checkout is handled by PayRam. Winnings, refunds and withdrawal holds stay recorded in the internal wallet ledger.",
      ticketGoodLuck: "You have a ticket for this draw. Good luck.",
      allDraws: "All Draws",
      myTickets: "My Tickets",
      transactions: "Transactions",
      withdrawals: "Withdrawals",
      noDraws: "No draws yet.",
      noTickets: "No tickets yet.",
      noTransactions: "No transactions yet.",
      noWithdrawals: "No withdrawal requests yet.",
      active: "Active",
      completed: "Completed",
      pending: "Pending",
      tickets: "tickets",
      winners: "Winners",
      youWon: "You won",
      requestWithdrawal: "Request Withdrawal",
      available: "Available",
      iban: "IBAN",
      amount: "Amount",
      createWithdrawal: "Create Withdrawal Request",
      creatingRequest: "Creating request...",
      withdrawalTo: "Withdrawal to",
      ticketNumber: "Ticket Number",
      draw: "Draw",
      entry: "Entry",
      entered: "ENTERED",
      ledgerFooter: "Wallet, tickets and withdrawal activity is recorded in the platform ledger.",
      noActiveDraw: "No active draw available",
      withdrawalCreated: "Withdrawal request created",
      withdrawalFailed: "Withdrawal request failed",
      ticketIssued: "Ticket issued",
      invoiceCreated: "Ticket invoice created. Waiting for payment confirmation.",
      paymentCancelled: "Ticket payment checkout was cancelled",
      paymentReturned: "Ticket payment returned from checkout. Waiting for provider confirmation.",
      syncFailed: "Ticket payment status sync failed"
    },
    sk: {
      tagline: "Kde \u0161ance hraj\u00FA v prospech hr\u00E1\u010Dov",
      walletBalance: "Zostatok pe\u0148a\u017Eenky",
      locked: "Zamknut\u00E9",
      welcome: "Vitajte,",
      liveDesc: "V\u00E1\u0161 \u017Eiv\u00FD lot\u00E9riov\u00FD dashboard",
      activeNow: "Pr\u00E1ve akt\u00EDvne",
      prizePool: "V\u00FDhern\u00FD fond",
      guaranteedFirstPrize: "Garantovan\u00E1 1. cena",
      mute: "Stlmi\u0165 zvuk",
      unmute: "Zapn\u00FA\u0165 zvuk",
      logout: "Odhl\u00E1si\u0165 sa",
      ticketsRemainingFomo: "l\u00EDstkov zost\u00E1va — \u017Erebovanie sa spust\u00ED po predaji 2000",
      fillProgress: "Nap\u013A\u0148a sa",
      withdraw: "Vyplati\u0165",
      buyTicket: "K\u00FApi\u0165 l\u00EDstok",
      preparingInvoice: "Pripravuje sa fakt\u00FAra...",
      ticketPurchased: "L\u00EDstok zak\u00FApen\u00FD",
      ticketNote: "Platba za l\u00EDstok prebieha cez PayRam. V\u00FDhry, refundy a pozastaven\u00E9 prostriedky s\u00FA zaznamenan\u00E9 v internom ledgeri.",
      ticketGoodLuck: "M\u00E1te l\u00EDstok pre toto \u017Erebovanie. Ve\u013Ea \u0161\u0165astia.",
      allDraws: "V\u0161etky kol\u00E1",
      myTickets: "Moje l\u00EDstky",
      transactions: "Transakcie",
      withdrawals: "V\u00FDbery",
      noDraws: "Zatia\u013E \u017Eiadne kol\u00E1.",
      noTickets: "Zatia\u013E \u017Eiadne l\u00EDstky.",
      noTransactions: "Zatia\u013E \u017Eiadne transakcie.",
      noWithdrawals: "Zatia\u013E \u017Eiadne \u017Eiadosti o v\u00FDber.",
      active: "Akt\u00EDvne",
      completed: "Ukon\u010Den\u00E9",
      pending: "\u010Cakaj\u00FAce",
      tickets: "l\u00EDstkov",
      winners: "V\u00FDhercovia",
      youWon: "Vyhrali ste",
      requestWithdrawal: "\u017Eiados\u0165 o v\u00FDber",
      available: "Dostupn\u00E9",
      iban: "IBAN",
      amount: "Suma",
      createWithdrawal: "Vytvori\u0165 \u017Eiados\u0165 o v\u00FDber",
      creatingRequest: "Vytvára sa \u017Eiados\u0165...",
      withdrawalTo: "V\u00FDber na",
      ticketNumber: "\u010C\u00EDslo l\u00EDstka",
      draw: "Kolo",
      entry: "Vstup",
      entered: "ZARADEN\u00DD",
      ledgerFooter: "Pe\u0148a\u017Eenka, l\u00EDstky a v\u00FDbery s\u00FA zaznamenan\u00E9 v ledgeri platformy.",
      noActiveDraw: "Moment\u00E1lne \u017Eiadne akt\u00EDvne \u017Erebovanie",
      withdrawalCreated: "\u017Eiados\u0165 o v\u00FDber vytvoren\u00E1",
      withdrawalFailed: "\u017Eiados\u0165 o v\u00FDber zlyhala",
      ticketIssued: "L\u00EDstok vydan\u00FD",
      invoiceCreated: "Fakt\u00FAra za l\u00EDstok vytvoren\u00E1. \u010Cak\u00E1 sa na potvrdenie platby.",
      paymentCancelled: "Platba za l\u00EDstok bola zru\u0161en\u00E1",
      paymentReturned: "Platba za l\u00EDstok sa vr\u00E1tila z checkoutu. \u010Cak\u00E1 sa na potvrdenie.",
      syncFailed: "Synchroniz\u00E1cia stavu platby zlyhala"
    },
    de: {
      tagline: "Wo die Chancen f\u00FCr Spieler sprechen",
      walletBalance: "Kontostand",
      locked: "Gesperrt",
      welcome: "Willkommen,",
      liveDesc: "Ihr Live-Lotterie-Dashboard",
      activeNow: "Jetzt aktiv",
      prizePool: "Preispool",
      guaranteedFirstPrize: "Garantierter 1. Preis",
      mute: "Ton stumm",
      unmute: "Ton ein",
      logout: "Abmelden",
      ticketsRemainingFomo: "Tickets verbleibend — Ziehung startet bei 2000 verkauften",
      fillProgress: "F\u00FCllt sich",
      withdraw: "Auszahlen",
      buyTicket: "Ticket kaufen",
      preparingInvoice: "Rechnung wird vorbereitet...",
      ticketPurchased: "Ticket gekauft",
      ticketNote: "Die Ticketzahlung wird \u00FCber PayRam abgewickelt. Gewinne, R\u00FCckerstattungen und Auszahlungssperren werden im internen Ledger erfasst.",
      ticketGoodLuck: "Sie haben ein Ticket f\u00FCr diese Ziehung. Viel Gl\u00FCck.",
      allDraws: "Alle Ziehungen",
      myTickets: "Meine Tickets",
      transactions: "Transaktionen",
      withdrawals: "Auszahlungen",
      noDraws: "Noch keine Ziehungen.",
      noTickets: "Noch keine Tickets.",
      noTransactions: "Noch keine Transaktionen.",
      noWithdrawals: "Noch keine Auszahlungsantr\u00E4ge.",
      active: "Aktiv",
      completed: "Abgeschlossen",
      pending: "Ausstehend",
      tickets: "Tickets",
      winners: "Gewinner",
      youWon: "Sie haben gewonnen",
      requestWithdrawal: "Auszahlung beantragen",
      available: "Verf\u00FCgbar",
      iban: "IBAN",
      amount: "Betrag",
      createWithdrawal: "Auszahlungsantrag erstellen",
      creatingRequest: "Antrag wird erstellt...",
      withdrawalTo: "Auszahlung an",
      ticketNumber: "Ticketnummer",
      draw: "Ziehung",
      entry: "Eintritt",
      entered: "EINGETRAGEN",
      ledgerFooter: "Wallet, Tickets und Auszahlungsaktivit\u00E4ten werden im Plattform-Ledger erfasst.",
      noActiveDraw: "Derzeit keine aktive Ziehung verf\u00FCgbar",
      withdrawalCreated: "Auszahlungsantrag erstellt",
      withdrawalFailed: "Auszahlungsantrag fehlgeschlagen",
      ticketIssued: "Ticket ausgestellt",
      invoiceCreated: "Ticketrechnung erstellt. Warten auf Zahlungsbest\u00E4tigung.",
      paymentCancelled: "Ticketzahlung wurde storniert",
      paymentReturned: "Ticketzahlung vom Checkout zur\u00FCckgekehrt. Warten auf Best\u00E4tigung.",
      syncFailed: "Synchronisierung des Zahlungsstatus fehlgeschlagen"
    }
  },

  // ─── TICKET COUNTER ───
  ticketCounter: {
    en: { ticketsSold: "Tickets Sold", filled: "filled", remaining: "remaining", live: "Live data", noDraw: "No active draw", completed: "Completed" },
    sk: { ticketsSold: "Predan\u00FDch l\u00EDstkov", filled: "naplnen\u00E9", remaining: "zost\u00E1va", live: "Live \u00FAdaje", noDraw: "\u017Diadne akt\u00EDvne kolo", completed: "Ukon\u010Den\u00E9" },
    de: { ticketsSold: "Verkaufte Tickets", filled: "gef\u00FCllt", remaining: "verbleibend", live: "Live-Daten", noDraw: "Keine aktive Ziehung", completed: "Abgeschlossen" }
  },

  // ─── PULSE GRID (RNG visualization) ───
  pulseGrid: {
    en: {
      label: "RANDOMNESS \u00B7 LIVE",
      tooltip: "Draws are powered by secrets.SystemRandom() \u2014 the same CSPRNG class used by banking systems."
    },
    sk: {
      label: "N\u00C1HODNOS\u0164 \u00B7 LIVE",
      tooltip: "Losovania poh\u00E1\u0148a secrets.SystemRandom() \u2014 rovnak\u00FD CSPRNG ako pou\u017E\u00EDvaj\u00FA bankov\u00E9 syst\u00E9my."
    },
    de: {
      label: "ZUFALL \u00B7 LIVE",
      tooltip: "Ziehungen laufen \u00FCber secrets.SystemRandom() \u2014 derselbe CSPRNG, den auch Banksysteme nutzen."
    }
  },

  // ─── VERIFICATION WIZARD ───
  verification: {
    en: {
      stepLabel: "Step", of: "of", next: "Continue",
      step1Title: "Scan your ID and take a selfie",
      step1Desc: "Prepare your ID card or other identification document. Upload the front and back of the document and then a selfie. Allowed formats: JPG, PNG or PDF; selfie must be an image.",
      idFront: "Front of ID", idBack: "Back of ID", selfie: "Selfie",
      upload: "Choose file", uploaded: "Uploaded",
      step2Title: "Enter your bank account",
      step2Desc: "Enter the bank account where we will send your winnings.",
      iban: "IBAN",
      step3Title: "Email address confirmation",
      step3Desc: "To complete registration, enter the code we sent to your email address.",
      emailCode: "Email code",
      doneTitle: "Registration complete",
      doneDesc: "Your account is verified. You can continue to your dashboard.",
      goToDashboard: "Go to dashboard",
      resendCode: "Resend code",
      resendIn: "Resend in"
    },
    sk: {
      stepLabel: "Krok", of: "z", next: "Pokra\u010Dova\u0165",
      step1Title: "Oskenuj svoj ob\u010Diansky a sprav si selfie",
      step1Desc: "Priprav si ob\u010Diansky preukaz alebo in\u00FD doklad toto\u017Enosti. Nahraj predn\u00FA a zadn\u00FA stranu dokladu a n\u00E1sledne selfie. Povolen\u00E9 s\u00FA JPG, PNG alebo PDF; selfie mus\u00ED by\u0165 obr\u00E1zok.",
      idFront: "Predn\u00E1 strana dokladu", idBack: "Zadn\u00E1 strana dokladu", selfie: "Selfie",
      upload: "Vybra\u0165 s\u00FAbor", uploaded: "Nahran\u00E9",
      step2Title: "Zadaj svoj bankov\u00FD \u00FA\u010Det",
      step2Desc: "Vypl\u0148 bankov\u00FD \u00FA\u010Det, na ktor\u00FD ti budeme posiela\u0165 v\u00FDhry.",
      iban: "IBAN",
      step3Title: "Potvrdenie emailovej adresy",
      step3Desc: "Pre \u00FAspe\u0161n\u00E9 dokon\u010Denie registr\u00E1cie zadaj k\u00F3d, ktor\u00FD sme poslali na tvoju emailov\u00FA adresu.",
      emailCode: "Emailov\u00FD k\u00F3d",
      doneTitle: "Registr\u00E1cia dokon\u010Den\u00E1",
      doneDesc: "\u00DA\u010Det je overen\u00FD. M\u00F4\u017Ee\u0161 pokra\u010Dova\u0165 do svojho dashboardu.",
      goToDashboard: "Prejs\u0165 do dashboardu",
      resendCode: "Posla\u0165 k\u00F3d znovu",
      resendIn: "Posla\u0165 znova o"
    },
    de: {
      stepLabel: "Schritt", of: "von", next: "Weiter",
      step1Title: "Scannen Sie Ihren Ausweis und machen Sie ein Selfie",
      step1Desc: "Bereiten Sie Ihren Personalausweis oder ein anderes Ausweisdokument vor. Laden Sie die Vorder- und R\u00FCckseite des Dokuments und ein Selfie hoch. Erlaubte Formate: JPG, PNG oder PDF; Selfie muss ein Bild sein.",
      idFront: "Vorderseite des Ausweises", idBack: "R\u00FCckseite des Ausweises", selfie: "Selfie",
      upload: "Datei ausw\u00E4hlen", uploaded: "Hochgeladen",
      step2Title: "Geben Sie Ihr Bankkonto ein",
      step2Desc: "Geben Sie das Bankkonto ein, auf das wir Ihre Gewinne senden.",
      iban: "IBAN",
      step3Title: "E-Mail-Adresse best\u00E4tigen",
      step3Desc: "Um die Registrierung abzuschlie\u00DFen, geben Sie den Code ein, den wir an Ihre E-Mail-Adresse gesendet haben.",
      emailCode: "E-Mail-Code",
      doneTitle: "Registrierung abgeschlossen",
      doneDesc: "Ihr Konto ist verifiziert. Sie k\u00F6nnen zu Ihrem Dashboard fortfahren.",
      goToDashboard: "Zum Dashboard",
      resendCode: "Code erneut senden",
      resendIn: "Erneut senden in"
    }
  },

  // ─── ADMIN DASHBOARD ───
  admin: {
    en: {
      title: "Admin Dashboard",
      tagline: "Where odds favor players",
      overview: "Overview",
      totalUsers: "Total Users",
      totalDraws: "Total Draws",
      totalTickets: "Total Tickets",
      totalRevenue: "Total Revenue",
      systemReadiness: "System Readiness",
      testEmail: "Test Email",
      smtpNotConfigured: "SMTP not configured",
      autopilot: "Run Autopilot",
      users: "Users",
      kycReview: "KYC Review",
      payments: "Payments",
      riskFlags: "Risk Flags",
      auditLog: "Audit Log",
      createDraw: "Create Draw",
      accountSecurity: "Account Security",
      currentPassword: "Current Password",
      newPassword: "New Password (min 12 characters)",
      confirmNewPassword: "Confirm New Password",
      changePassword: "Change Password",
      changingPassword: "Changing...",
      noUsers: "No users.",
      noKyc: "No pending KYC cases.",
      noPayments: "No payments.",
      noRisk: "No risk flags.",
      noAudit: "No audit logs.",
      completedDraws: "Completed",
      openRisk: "Open Risk"
    },
    sk: {
      title: "Admin Dashboard",
      tagline: "Kde \u0161ance hraj\u00FA v prospech hr\u00E1\u010Dov",
      overview: "Preh\u013Ead",
      totalUsers: "Celkovo pou\u017E\u00EDvate\u013Eov",
      totalDraws: "Celkovo k\u00F4l",
      totalTickets: "Celkovo l\u00EDstkov",
      totalRevenue: "Celkov\u00FD pr\u00EDjem",
      systemReadiness: "Pripravenost\u0165 syst\u00E9mu",
      testEmail: "Testovac\u00ED email",
      smtpNotConfigured: "SMTP nie je nakonfigurovan\u00E9",
      autopilot: "Spusti\u0165 Autopilot",
      users: "Pou\u017E\u00EDvatelia",
      kycReview: "KYC Kontrola",
      payments: "Platby",
      riskFlags: "Rizikov\u00E9 flagy",
      auditLog: "Audit Log",
      createDraw: "Vytvori\u0165 kolo",
      accountSecurity: "Bezpe\u010Dnos\u0165 \u00FA\u010Dtu",
      currentPassword: "Aktu\u00E1lne heslo",
      newPassword: "Nov\u00E9 heslo (min 12 znakov)",
      confirmNewPassword: "Potvr\u010Fte nov\u00E9 heslo",
      changePassword: "Zmeni\u0165 heslo",
      changingPassword: "Men\u00ED sa...",
      noUsers: "\u017Diadni pou\u017E\u00EDvatelia.",
      noKyc: "\u017Diadne \u010Dakaj\u00FAce KYC pr\u00EDpady.",
      noPayments: "\u017Diadne platby.",
      noRisk: "\u017Diadne rizikov\u00E9 flagy.",
      noAudit: "\u017Diadne audit logy.",
      completedDraws: "Dokon\u010Den\u00E9",
      openRisk: "Otvoren\u00E9 rizik\u00E1"
    },
    de: {
      title: "Admin Dashboard",
      tagline: "Wo die Chancen f\u00FCr Spieler sprechen",
      overview: "\u00DCbersicht",
      totalUsers: "Benutzer gesamt",
      totalDraws: "Ziehungen gesamt",
      totalTickets: "Tickets gesamt",
      totalRevenue: "Gesamtumsatz",
      systemReadiness: "Systembereitschaft",
      testEmail: "Test-E-Mail",
      smtpNotConfigured: "SMTP nicht konfiguriert",
      autopilot: "Autopilot starten",
      users: "Benutzer",
      kycReview: "KYC-Pr\u00FCfung",
      payments: "Zahlungen",
      riskFlags: "Risikoflaggen",
      auditLog: "Audit-Protokoll",
      createDraw: "Ziehung erstellen",
      accountSecurity: "Kontosicherheit",
      currentPassword: "Aktuelles Passwort",
      newPassword: "Neues Passwort (min. 12 Zeichen)",
      confirmNewPassword: "Neues Passwort best\u00E4tigen",
      changePassword: "Passwort \u00E4ndern",
      changingPassword: "\u00C4ndert sich...",
      noUsers: "Keine Benutzer.",
      noKyc: "Keine ausstehenden KYC-F\u00E4lle.",
      noPayments: "Keine Zahlungen.",
      noRisk: "Keine Risikoflaggen.",
      noAudit: "Keine Audit-Protokolle.",
      completedDraws: "Abgeschlossen",
      openRisk: "Offene Risiken"
    }
  }
};

/**
 * Get translations for a section + language, with EN fallback.
 * Usage: const t = getT('dashboard', language);
 */
export function getT(section, language) {
  const sectionData = translations[section];
  if (!sectionData) return {};
  return sectionData[language] || sectionData.en || {};
}
